const variants = {
  whiskey: { name: 'Whiskey / Peach', id: '44072482078819', image: 'https://cdn.shopify.com/s/files/1/0638/4956/2211/files/TransportTote-4.webp?v=1774645415', alt: 'Whiskey and Peach Transport Tote' },
  sand: { name: 'Sand / Gold', id: '44072482111587', image: 'https://cdn.shopify.com/s/files/1/0638/4956/2211/files/2_bc88cfa6-7877-4d35-9be9-d79c93480205.webp?v=1761675853', alt: 'Sand and Gold Transport Tote' },
  slate: { name: 'Slate / Evergreen', id: '44072482144355', image: 'https://cdn.shopify.com/s/files/1/0638/4956/2211/files/TransportTote-6.webp?v=1774645415', alt: 'Slate and Evergreen Transport Tote' }
};
let selected = 'whiskey';
const sticky = document.querySelector('#sticky');
const select = document.querySelector('#sticky-select');
const hero = document.querySelector('.hero');

function setTone(tone) {
  selected = tone;
  const v = variants[tone];
  document.querySelector('.tt-root').dataset.tone = tone;
  document.querySelector('#color-name').textContent = v.name;
  document.querySelector('#final-product').src = v.image;
  document.querySelector('#final-product').alt = v.alt;
  document.querySelector('#sticky-product').src = v.image;
  select.value = tone;
  document.querySelectorAll('[data-tone-button]').forEach((button) => {
    const active = button.dataset.toneButton === tone;
    button.classList.toggle('is-active', active);
    if (button.classList.contains('swatch')) button.setAttribute('aria-pressed', String(active));
  });
}

document.querySelectorAll('[data-tone-button]').forEach((button) => button.addEventListener('click', () => {
  setTone(button.dataset.toneButton);
  if (!button.classList.contains('swatch')) document.querySelector('#buy').scrollIntoView({ behavior: 'smooth' });
}));
select.addEventListener('change', () => setTone(select.value));

const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.05 });
observer.observe(hero);

document.querySelectorAll('.carry-toggle button').forEach((button) => button.addEventListener('click', () => {
  document.querySelectorAll('.carry-toggle button').forEach((item) => item.classList.remove('is-active'));
  button.classList.add('is-active');
}));

document.querySelectorAll('.add-to-cart').forEach((button) => button.addEventListener('click', async () => {
  button.disabled = true;
  const original = button.textContent;
  button.textContent = 'Adding…';
  try {
    if (window.Rarely?.cart) await window.Rarely.cart({ variantId: variants[selected].id, quantity: 1 });
    else if (location.protocol.startsWith('http') && !location.hostname.includes('127.0.0.1') && !location.hostname.includes('localhost')) {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variants[selected].id), quantity: 1 }] }) });
      if (!response.ok) throw new Error('Cart request failed');
    }
    if (window.fbq) window.fbq('track', 'AddToCart', { content_ids: [variants[selected].id], content_type: 'product', value: 95, currency: 'USD' });
    const toast = document.querySelector('#toast');
    toast.textContent = `${variants[selected].name} added to cart`;
    toast.classList.add('is-visible');
    setTimeout(() => toast.classList.remove('is-visible'), 2600);
    button.textContent = 'Added';
  } catch (error) {
    button.textContent = 'Try again';
  } finally {
    setTimeout(() => { button.disabled = false; button.textContent = original; }, 1600);
  }
}));

if (window.fbq) window.fbq('track', 'ViewContent', { content_ids: [variants[selected].id], content_type: 'product', value: 95, currency: 'USD' });
